/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { ApiRequestBuilderNavigationMetadata, type ApiRequestBuilder } from './api/index.js';
// @ts-ignore
import { FaviconIcoRequestBuilderRequestsMetadata, type FaviconIcoRequestBuilder } from './faviconIco/index.js';
// @ts-ignore
import { createHomeEndpoint_HomeResponseFromDiscriminatorValue, type HomeEndpoint_HomeResponse } from './models/index.js';
// @ts-ignore
import { type ValidateConfigRequestBuilder, ValidateConfigRequestBuilderRequestsMetadata } from './validateConfig/index.js';
// @ts-ignore
import { apiClientProxifier, ParseNodeFactoryRegistry, SerializationWriterFactoryRegistry, type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestAdapter, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';
// @ts-ignore
import { FormParseNodeFactory, FormSerializationWriterFactory } from '@microsoft/kiota-serialization-form';
// @ts-ignore
import { JsonParseNodeFactory, JsonSerializationWriterFactory } from '@microsoft/kiota-serialization-json';
// @ts-ignore
import { MultipartSerializationWriterFactory } from '@microsoft/kiota-serialization-multipart';
// @ts-ignore
import { TextParseNodeFactory, TextSerializationWriterFactory } from '@microsoft/kiota-serialization-text';

/**
 * The main entry point of the SDK, exposes the configuration and the fluent API.
 */
export interface ApiClient extends BaseRequestBuilder<ApiClient> {
    /**
     * The api property
     */
    get api(): ApiRequestBuilder;
    /**
     * The faviconIco property
     */
    get faviconIco(): FaviconIcoRequestBuilder;
    /**
     * The validateConfig property
     */
    get validateConfig(): ValidateConfigRequestBuilder;
    /**
     * Returns the API's name, documentation and contact links, and the running build's version and date. Unauthenticated, so it can be used to confirm an environment is reachable and to check which build it is serving before raising an issue. Use /health for liveness checks — this endpoint is informational and is not a health probe.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<HomeEndpoint_HomeResponse>}
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<HomeEndpoint_HomeResponse | undefined>;
    /**
     * Returns the API's name, documentation and contact links, and the running build's version and date. Unauthenticated, so it can be used to confirm an environment is reachable and to check which build it is serving before raising an issue. Use /health for liveness checks — this endpoint is informational and is not a health probe.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Instantiates a new {@link ApiClient} and sets the default values.
 * @param requestAdapter The request adapter to use to execute the requests.
 */
// @ts-ignore
export function createApiClient(requestAdapter: RequestAdapter) {
    if (requestAdapter === undefined) {
        throw new Error("requestAdapter cannot be undefined");
    }
    let serializationWriterFactory : SerializationWriterFactoryRegistry
    let parseNodeFactoryRegistry : ParseNodeFactoryRegistry
    
    if (requestAdapter.getParseNodeFactory() instanceof ParseNodeFactoryRegistry) {
        parseNodeFactoryRegistry = requestAdapter.getParseNodeFactory() as ParseNodeFactoryRegistry
    } else {
        throw new Error("requestAdapter.getParseNodeFactory() is not a ParseNodeFactoryRegistry")
    }
    
    if (requestAdapter.getSerializationWriterFactory() instanceof SerializationWriterFactoryRegistry) {
        serializationWriterFactory = requestAdapter.getSerializationWriterFactory() as SerializationWriterFactoryRegistry
    } else {
        throw new Error("requestAdapter.getSerializationWriterFactory() is not a SerializationWriterFactoryRegistry")
    }
    
    serializationWriterFactory.registerDefaultSerializer(JsonSerializationWriterFactory);
    serializationWriterFactory.registerDefaultSerializer(TextSerializationWriterFactory);
    serializationWriterFactory.registerDefaultSerializer(FormSerializationWriterFactory);
    serializationWriterFactory.registerDefaultSerializer(MultipartSerializationWriterFactory);
    
    const backingStoreFactory = requestAdapter.getBackingStoreFactory();
    parseNodeFactoryRegistry.registerDefaultDeserializer(JsonParseNodeFactory, backingStoreFactory);
    parseNodeFactoryRegistry.registerDefaultDeserializer(TextParseNodeFactory, backingStoreFactory);
    parseNodeFactoryRegistry.registerDefaultDeserializer(FormParseNodeFactory, backingStoreFactory);
    if (requestAdapter.baseUrl === undefined || requestAdapter.baseUrl === null || requestAdapter.baseUrl === "") {
        requestAdapter.baseUrl = "https://api-dev.nymblecommerce.com";
    }
    const pathParameters: Record<string, unknown> = {
        "baseurl": requestAdapter.baseUrl,
    };
    return apiClientProxifier<ApiClient>(requestAdapter, pathParameters, ApiClientNavigationMetadata, ApiClientRequestsMetadata);
}
/**
 * Uri template for the request builder.
 */
export const ApiClientUriTemplate = "{+baseurl}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const ApiClientNavigationMetadata: Record<Exclude<keyof ApiClient, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    api: {
        navigationMetadata: ApiRequestBuilderNavigationMetadata,
    },
    faviconIco: {
        requestsMetadata: FaviconIcoRequestBuilderRequestsMetadata,
    },
    validateConfig: {
        requestsMetadata: ValidateConfigRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const ApiClientRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: ApiClientUriTemplate,
        responseBodyContentType: "application/json",
        adapterMethodName: "send",
        responseBodyFactory:  createHomeEndpoint_HomeResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
